import { Component, OnInit, Input } from '@angular/core';
import {Router, ActivatedRoute,NavigationExtras} from '@angular/router';
import {Configuration} from '../../../app.constants';
import { AppConfigService } from 'src/app/app-config.service';
import { SystemmenuService, SystemModule, ContactSuport } from '../../../shared/services/systemmenu.service';


@Component({
  selector: 'checklist-registration-info',
  templateUrl: './checklist-registration-info.component.html',
  styleUrls: ['./checklist-registration-info.component.scss']
})

export class ChecklistRegistrationInfoComponent implements OnInit {
  @Input() index:any;
  @Input() isON:boolean;
  disabledAgreement: boolean = true;
  popupVisible:boolean=false;
  LanguageLabel: any;
  public logoPath :string="";
  
  List1: any;
  menuItems: any[] = [];
  htmlcontent:string;
  private _compactMode = false;
  menuId: number;
  submenupath:string;

  popupTitleInst:string;
  popupVisibleInst:boolean=false;
  ContactList:any;
  SupportContact:string;
  constructor(private router: Router,private configuration : Configuration,
    private appConfigService : AppConfigService,
    private systemMenuService:SystemmenuService) { 
    this.logoPath = this.appConfigService.LogoPath;
  }

  ngOnInit() {
    this.LanguageLabel =this.configuration.LanguageLabel[0];
    this.configuration.RegistrationConfirm=false;
    debugger
    this.popupTitleInst=this.LanguageLabel.SupportContacts;
    this.SupportContact= this.configuration.SupportContact;
    /* this.systemMenuService.GetContactList()
       .subscribe((data: ContactSuport[]) => this.ContactList = data,
       error => {
         //alert(error);
       },
       () => {
       });   */
       this.getSystemMenu();
  }
  getSystemMenu() {
    this.systemMenuService.GetUserGroupIDforPortal()
    .subscribe((data:SystemModule[]) => this.List1 = data,
    error => {
    alert(error);
      },
      () => {
        if(this.List1.length>0){
          this.configuration.SysUsrGrpID=this.List1[0].SysUsrGrpID;
         
            this.menuId = 0;
            this.systemMenuService.getAllMenuByGroupId(this.configuration.SysUsrGrpID,'En').subscribe(
              (data: SystemModule[]) => {
      
                for (var i = 0; i < data.length; i++) {
      
                  var module = {
                    id: 0,
                    text: '',
                    path: '',
                    icon: '',
                    items: []
                  }
                  this.menuId = this.menuId + 1;
                var sysModueData = data[i];
                    module.icon = '';
                  module.path = "/";
                  module.text = sysModueData.SysModName;
                  module.id = this.menuId; 
                  if ((sysModueData.SysSubModList)) {
      
                    for (var p = 0; p < sysModueData.SysSubModList.length; p++) {
                      var item = {
                        id: 0,
                        text: '',
                        path: '',
                        icon: '',
                        items: [],
                        SysSubModID:0,
                        Instruction:'',
                        InStructionInDevnagri:'',
                      }
      
                      this.menuId = this.menuId + 1;
                      var programModule = sysModueData.SysSubModList[p];
                      item.icon = programModule.SubModuleImageClass,
                      item.path = programModule.SysSubModShrtName;
                      item.text = programModule.SysSubModName;
                      item.id = this.menuId; 
                      item.SysSubModID=programModule.SysSubModID;//programModule.SysSubModID;
                      if ((programModule.SysProgList) && (programModule.SysProgList.length > 0)) {
                        for (var x = 0; x < programModule.SysProgList.length; x++) {
                          var programItem = {
                            id: 0,
                            text: '',
                            path: '',
                            icon: '',
                            AccessPath:'',
                            SysSubModID:0,
                            Instruction:'',
                            InStructionInDevnagri:'',
                          }
                          this.menuId = this.menuId + 1;
                          var systemProgram = programModule.SysProgList[x];
                         
                          programItem.path = "/"+ item.path+"/"+systemProgram.GridFormToOpen;
                          programItem.text = systemProgram.SysProgName;
                          programItem.id = this.menuId;
                          programItem.AccessPath=systemProgram.GridFormToOpen;
                          programItem.icon=systemProgram.PrgImgClass// systemProgram.SysProgID;
                          programItem.SysSubModID=0;
                          programItem.Instruction=systemProgram.Instruction;
                          programItem.InStructionInDevnagri=systemProgram.InStructionInDevnagri;
                          item.items.push(programItem);
                        }
                      }
                      module.items.push(item);
                    }
                    this.configuration.progoramlist = module.items[0].items;
                    for (var i = 0; i < this.configuration.progoramlist.length; i++) {
                      if(this.configuration.progoramlist[i].AccessPath=="checklist-registration-info"){
                        if(this.configuration.SelectedLanguage=="En" && this.configuration.progoramlist[i].InStructionInDevnagri=="") {
                          this.htmlcontent=this.configuration.progoramlist[i].Instruction;
                        }else if(this.configuration.SelectedLanguage!="En" && this.configuration.progoramlist[i].InStructionInDevnagri!="") { 
                          this.htmlcontent=this.configuration.progoramlist[i].InStructionInDevnagri;
                        }else{
                          this.htmlcontent=this.configuration.progoramlist[i].Instruction;
                        }
                      }
                    }
                  }
                }
              },
              error => {
                alert(error);
              },
              () => {
              });
          
        }
              
      }); 

   

  }
  values='';
  applyClicked(value) {
    this.values=value;
    console.log(this.values);
  }
  changeCheck(event){
    console.log(event.value);
    this.disabledAgreement = !event.value;
  }
  postpage(){debugger
   // this.router.navigate(['studentportal/registrationform']);
     this.configuration.RegistrationConfirm=true;
     this.popupVisible=true;
     let navigationExtras: NavigationExtras = {
      queryParams: { "OldStudent" : "N"}
      }
     this.router.navigate(['/registrationForm'],navigationExtras);
  
  }
  OldStudent(){
    let navigationExtras: NavigationExtras = {
      queryParams: { "OldStudent" : "Y"}
      }
    this.router.navigate(['/registrationForm'],navigationExtras);
  }
  NewStudent(){
    let navigationExtras: NavigationExtras = {
      queryParams: { "OldStudent" : "N"}
      }
      this.router.navigate(['/registrationForm'],navigationExtras);
      
  }
  redirectToLogin(){
    this.router.navigate(['/login-form']);
  }
  SupportContactsclick(){
    this.popupVisibleInst=true;
  }
  cancelClick(){
    this.popupVisibleInst=false;
  }
}
